import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT, withQuery } from '../utilities/FetchHelper';
import memoryCache from '../utilities/MemoryCache';

const IATA_CACHE_KEY = 'iata'

class DestinationsService {

    getHotelDestinations(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_DESTINATIONS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getIataLocations = async (data) => {
        const { queryParams, ...urlParams } = data
        const countryCode = queryParams?.countryCode
        const stateCode = queryParams?.stateCode
        const commonAbbreviation = queryParams?.commonAbbreviation

        let cacheKey = stateCode
            ? `${IATA_CACHE_KEY}_${countryCode}_${stateCode}`
            : `${IATA_CACHE_KEY}_${countryCode}`
        if (commonAbbreviation) {
            cacheKey += `_${commonAbbreviation}`
        }

        const cached = memoryCache.get(cacheKey)
        if (cached) {
            return cached
        }

        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_IATA_LOCATIONS
        for (const key in urlParams) {
            url = url.replace('{' + key + '}', urlParams[key])
        }
        if (queryParams) {
            url = withQuery(url, queryParams)
        }

        const response = await fetchJSON(url, secureGET())
        memoryCache.set(cacheKey, response)
        return response
    }

    getAcceptableValues(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_DESTINATION_ACCEPTABLE_VALUES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putHotelDestinations(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_DESTINATIONS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        const formData = data.formData
        let putData = {
            hotelCode: data.hotelCode,
            hotelDestinations: formData
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

}

export default new DestinationsService()